import { ConfirmationRequestStatus } from '../constants/confirmationRequest'
import {
  AdmissionGroupStatus,
  AdmissionGroupStatusName,
} from '../constants/admissionGroup'
import type {
  AdmissionGroup,
  AdmissionGroupSerialized,
} from '../admissionGroup'
import { PaymentStatus } from '../constants/pricing'

export function getConfirmationRequestTagLabel(
  status?: ConfirmationRequestStatus | null
): string {
  switch (status) {
    case ConfirmationRequestStatus.COMPLETED:
      return 'Completed'
    case ConfirmationRequestStatus.CANCELLED:
      return 'Canceled'
    case ConfirmationRequestStatus.REFUNDED:
      return 'Refunded'
    // case ConfirmationRequestStatus.PENDING:
    default:
      return 'Pending'
  }
}

export const admissionGroupPendingPaymentLabel = 'Pending'
export const admissionGroupCheckedInLabel = 'Checked In'

export function getAdmissionGroupStatusLabel(
  status?: AdmissionGroupStatus | null
): string {
  if (!status) return 'Expected'

  switch (status) {
    case AdmissionGroupStatus.CANCELLED:
    case AdmissionGroupStatus.DENIED:
      return AdmissionGroupStatusName[status] ?? status
    case AdmissionGroupStatus.CHECKED_IN_FULL:
    case AdmissionGroupStatus.CHECKED_IN:
    case AdmissionGroupStatus.CHECKED_IN_PARTIAL:
      return AdmissionGroupStatusName[status] ?? status
    case AdmissionGroupStatus.CLOSED:
    case AdmissionGroupStatus.CONFIRMED:
      return AdmissionGroupStatusName[status] ?? status
    default:
      return AdmissionGroupStatusName[status] ?? status
  }
}

export function getAdmissionGroupPaymentStatusLabel(
  admissionGroup: AdmissionGroup | AdmissionGroupSerialized
): string | null {
  const paymentStatus = admissionGroup.paymentStatus

  switch (paymentStatus) {
    case PaymentStatus.FULL:
      return 'Full'
    case PaymentStatus.DEPOSIT:
      return 'Deposit'
    case PaymentStatus.CREDIT_CARD_ON_FILE:
      return 'Auth'
    default:
      return null
  }
}
